'use strict';

import template from './top_panel.html';

export default function saTopPanel(topPanel) {
  'ngInject';

  return {
    template: template,
    replace: true,
    transclude: true,
    scope: {},
    link: function ($scope) {
      $scope.close = topPanel.close.bind(topPanel);
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/common/top_panel/top_panel.directive.js